module.exports = __webpack_public_path__ + "img/fengtao(2).42dc0140.jpg";